import { useRef, useCallback } from 'react';
import {
  type RatablePairingItem,
  type RatableProductItem,
  RatableItemType,
} from './useRatableItems';

export type RatedItemCount = {
  pairingsQuantityUpvoted: Set<number>;
  productsQuantityUpvoted: Set<number>;
  pairingsQuantityDownvoted: Set<number>;
  productsQuantityDownvoted: Set<number>;
};

export function useRatedItemCount() {
  const ratedItemCount = useRef<RatedItemCount>({
    pairingsQuantityUpvoted: new Set<number>(),
    productsQuantityUpvoted: new Set<number>(),
    pairingsQuantityDownvoted: new Set<number>(),
    productsQuantityDownvoted: new Set<number>(),
  });

  const onRating = useCallback(
    ({
      item,
      rating,
    }: {
      item: RatablePairingItem | RatableProductItem;
      rating: boolean | null;
    }) => {
      if (item.type === RatableItemType.Pairing) {
        if (rating === true) {
          ratedItemCount.current.pairingsQuantityDownvoted.delete(
            item.pairingId
          );
          ratedItemCount.current.pairingsQuantityUpvoted.add(item.pairingId);
        } else if (rating === false) {
          ratedItemCount.current.pairingsQuantityDownvoted.add(item.pairingId);
          ratedItemCount.current.pairingsQuantityUpvoted.delete(item.pairingId);
        } else {
          ratedItemCount.current.pairingsQuantityDownvoted.delete(
            item.pairingId
          );
          ratedItemCount.current.pairingsQuantityUpvoted.delete(item.pairingId);
        }
      } else {
        if (rating === true) {
          ratedItemCount.current.productsQuantityDownvoted.delete(
            item.productId
          );
          ratedItemCount.current.productsQuantityUpvoted.add(item.productId);
        } else if (rating === false) {
          ratedItemCount.current.productsQuantityDownvoted.add(item.productId);
          ratedItemCount.current.productsQuantityUpvoted.delete(item.productId);
        } else {
          ratedItemCount.current.productsQuantityDownvoted.delete(
            item.productId
          );
          ratedItemCount.current.productsQuantityUpvoted.delete(item.productId);
        }
      }
    },
    []
  );

  return {
    onRating,
    ratedItemCount: ratedItemCount.current,
  };
}
